
document.addEventListener('DOMContentLoaded', function load() {
    function urldecode (str) {
        return decodeURIComponent((str + '')
            .replace(/%(?![\da-f]{2})/gi, function () {
            // PHP tolerates poorly formed escape sequences
            return '%25'
            })
            .replace(/\+/g, '%20'))
    }

    data = {"func":"shopifyGetPWUrl", "tag": 1, "m": "iframe", "c": ""};
    $.ajax({
        type: "POST",
        url: window.location.origin+"/a/greeting-cards/index.php",
        //url: 'https://dev1.printzware.com/seriouspig/index.php',
        crossDomain: true,
        data : data,
        dataType: "json",
        success: function (json_data, textStatus, jqXHR) {
            console.log(json_data);
            $("#pw_cards_iframe").attr("src", urldecode(json_data.modalURL));
        },
        error: function (json_data, textStatus, errorThrown) {
            console.log("PW Error: error getting pw iframe URL");
        }
    });

    data = {"func":"shopifyGetClientData"};
    $.ajax({
        type: "POST",
        url: window.location.origin+"/a/greeting-cards/index.php",
        crossDomain: true,
        data : data,
        dataType: "json",
        success: function (json_data, textStatus, jqXHR) {
 
            if($("body").hasClass("template-cart")){
                replacePWimagesCartPage(json_data.clientID);
            } else{
                setTimeout(function(){ 
                    replacePWimages(json_data.clientID);
                },500);
            }

           window.addEventListener('message', function(e) {
                // IMPORTANT: verify the sender before trusting the message
                
                if (e.origin !== urldecode(json_data.apiURL)) {
                    return;
                }

                var returnData;
                try {
                    // if printzware sends JSON, this is all you need:
                    returnData = JSON.parse(e.data);
                    console.log(returnData);
                } catch (err) {
                    // fallback: sender is posting a query-string-style payload
                    // e.g. "a=1&b=2" instead of real JSON
                    returnData = {};
                    decodeURIComponent(e.data).split('&').forEach(function(pair) {
                        var kv = pair.split('=');
                        returnData[kv[0]] = kv[1];
                    });
                }

                if(returnData.func == "addCard"){
                    var quantity = 1;
                    var data = {"quantity":quantity,"id":json_data.cardVariantID,"properties":{"PersonalisationID":returnData.yourOrderID}};

                    $.ajax({
                        type: 'POST',
                        url: window.location.origin+"/cart/add.js",
                        data: data,
                        crossDomain: true,
                        dataType: 'json',
                        success: function(json_data_cart, textStatus, jqXHR) {
                             if($("#upsellPopup").length){
                                $("#step1").hide();
                                $("#step2").show();
                                $("#step2").removeClass('hidden');
                             } else{
                                window.location = json_data.confirmURL
                             }
                        },
                        error: function (json_data_cart, textStatus, errorThrown) {
                            console.log('pw: pwShopifyAddProductToCart failed');
                        }
                    });
                }
            }, false);
        },
        error: function (json_data, textStatus, errorThrown) {
            console.log("PW Error: error getting pw client Data");
        }
    });

    function replacePWimagesCartPage(pwClientID){
        var textArray =  $(".sp-cart-items-list .sp-cart-item .sp-cart-item__body:contains('PersonalisationID')");
        textArray.each(function() {

            var cardID = this.innerText.match(/PersonalisationID:.*/);
            cardID = cardID[0];
            cardID = cardID.replace("PersonalisationID:", "").trim();
            cardID = cardID.match(/[^\s]+/);
            cardID = cardID[0];
            var rand = Math.floor(Math.random() * 10000);
            var newSrc = "https://pwcdn.net/thumbnails/"+pwClientID+"/"+cardID+".jpg?r="+rand;
            $(this).parent().find("img").addClass("pwThumbImage");
            $(this).parent().find("img").attr("src",newSrc);
            $(this).parent().find("img").attr("srcset",newSrc);
        });
    }

    function replacePWimages(pwClientID){

        var optionsBlocks = $(".cart-items .cart-item .cart-item__details:contains('PersonalisationID')");
      
        optionsBlocks.each(function() {
            var $options = $(this);

            var $dt = $options.find("dt").filter(function() {
            return $(this).text().indexOf("PersonalisationID") !== -1;
            });

            if ($dt.length === 0) return; 

            var cardID = $dt.next("dd").text().trim();

            if (!cardID) return;

            var rand = Math.floor(Math.random() * 10000);
            var newSrc = "https://pwcdn.net/thumbnails/"+pwClientID+"/"+cardID+".jpg?r="+rand;
            var $item = $options.closest(".cart-item");
            var $img = $item.find("img");

            $img.addClass("pwThumbImage");
            $img.attr("src", newSrc);
            $img.attr("srcset", newSrc);
        });

    }   

    /* function setCardsIframeHeight() {
        var iframe = document.getElementById('pw_cards_iframe');
        if (!iframe) return;
        iframe.style.height = window.innerHeight + 'px';
    }*/
   function setCardsIframeHeight() {
        var iframe = document.getElementById('pw_cards_iframe');
        if (!iframe) return;
        var h = window.visualViewport ? window.visualViewport.height : window.innerHeight;
       // iframe.style.height = (h * 0.85) + 'px';
       iframe.style.height = h + 'px';
    }

    // Run on load
    document.addEventListener('DOMContentLoaded', setCardsIframeHeight);

    // Run on every resize (window rotation, browser UI show/hide, etc.)
    window.addEventListener('resize', setCardsIframeHeight);

    var page_path = window.location.pathname;
    
    if(page_path == "/a/greeting-cards" || page_path == "/products/personalised-greeting-card"){
        window.location = '/pages/greeting-card';
    }



}, false);